// scroll animation for apply button
// getting the element Y offset position
function getElementY(query) {
  return (
    window.pageYOffset + document.querySelector(query).getBoundingClientRect().top - 100
  );
}

function doScrolling(element, duration) {
  let startingY = window.pageYOffset;
  let elementY = getElementY(element);
  // If element is close to page's bottom then window will scroll only to some position above the element.
  let targetY =
    document.body.scrollHeight - elementY < window.innerHeight
      ? document.body.scrollHeight - window.innerHeight
      : elementY;
  let diff = targetY - startingY;

  let start;

  if (!diff) return;

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    // Elapsed miliseconds since start of scrolling.
    let time = timestamp - start;
    // Get percent of completion in range [0, 1].
    let percent = Math.min(time / duration, 1);
    // scroll to  target
    window.scrollTo(0, startingY + diff * percent);

    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
}

// Apply event handlers. Example of firing the scrolling mechanism.
let btnElement = document.getElementById("applyBtn");
if (btnElement) {
  btnElement.addEventListener(
    "click",
    doScrolling.bind(null, "#careerForm", 100)
  );
}
